@if(versionedVessel){
<div class="row">
    <div class="col-md-5">
        <div class="card p-3">
            <div class="card-header">
                <h3 class="card-title">Manuals</h3>
            </div>
            <form #manualForm="ngForm">
                <div class="form-group mb-3 row align-items-center">
                    <app-material-auto-complete
                        id="dropdown1"
                        [placeholder]="'Type'"
                        [items]="typeList"
                        [formatter]="typeFormatter"
                        [(ngModel)]="manual.manualType"
                        name="manualType">
                    </app-material-auto-complete>
                </div>

                <div class="form-group mb-3 row align-items-center" >
                    <app-material-pg-input
                            label="File Name"
                            type="text"
                            id="fileName"
                            [(ngModel)]="manual.name"
                            name="manualName"
                            placeholder="Enter file name"
                            [required]="true" >
                    </app-material-pg-input>
                </div>

                <div class="form-group mb-3 row align-items-center">
                    <app-material-chunk-file-uploader
                        [accept]="'.pdf'"
                        [fileSize]="100000000"
                        name="uploadManualFile"
                        placeholder="'Upload File'"
                        [required]="true"
                        [(ngModel)]="doc"
                        (ngModelChange)="pdfFileUploaded($event)">
                    </app-material-chunk-file-uploader>
                </div>

                <div class="d-flex justify-content-end gap-2">
                    <button
                        mat-raised-button
                        mat-stroked-button
                        class="pull-right"
                        type="button"
                        (click)="addManual()"
                        [disabled]="!manualForm.form.valid || !manual.fileId">
                        Add
                    </button>

                </div>
            </form>
        </div>

        <div class="card p-3">
            <div class="card-header">
                <h3 class="card-title">Saved Manuals</h3>
            </div>
            @if(versionedVessel){
            <div class="table-responsive">
                <table class="table table-bordered table-striped table-sm mt-3">
                    <thead class="table-light">
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>File</th>
                        </tr>
                    </thead>
                    <tbody>
            @for (m of versionedVessel.data?.spec!.manuals; let i = $index; track $index) {
            <tr>
                <td class="text-wrap">{{ m.name }}</td>
                <td>{{ m.manualType }}</td>
                <td class="text-center">
                    <i
                        class="fa fa-file"
                        (click)="showManualDoc[i] = true">
                    </i>
                    <app-material-pdf-viewer-pop-up
                        [(show)]="showManualDoc[i]"
                        [fileId]="m.fileId">
                    </app-material-pdf-viewer-pop-up>
                </td>
            </tr>
            }
                    </tbody>
                </table>
            </div>
            }
        </div>
    </div>
</div>
}
